import StoreUtil from "../store.util.js";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  usersList: StoreUtil.state(),
};

const userModule = {
  state,
  mutations,
  actions,
  getters,
};

export default userModule;
